import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { CommonFilter } from '../../../../models';


@Injectable({ providedIn: 'root' })
export class AppealsReportService extends ApiService {
    endPoint = '/api/appeal-report';
    getAppealsByMonths(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/appeals-by-months`, filter);
    }

    getAppealsByServices(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/appeals-by-services`, filter);
    }

    getAppealsByContingents(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/appeals-by-contingents`, filter);
    }

    getAppealsByDiagnoses(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/appeals-by-diagnoses`, filter);
    }

    getAppealsByAges(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/appeals-by-ages`, filter);
    }

    getAppealsByGenders(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/appeals-by-genders`, filter);
    }
}
